import { defineStore } from 'pinia'
import { isUnifiedCommerce } from '@shared/constants'
import { checkPermissions } from '@shared/utils/permissions'
import { useAuthStore } from '@shared/store/auth'
import th from '@tillhub/javascript-sdk'

export const useProductsStore = defineStore('products', {
  state: () => ({
    selectedItems: [],
    allSelected: false,
    persistedFilters: {},
    productsCount: 1,
    bulkEditLimit: 500,
    duplicateProductLimit: 100
  }),
  actions: {
    clearSelectedItems() {
      // Assign rather than $patch: the object form of $patch deep-merges, so
      // `persistedFilters: {}` would keep every filter that was set before.
      this.selectedItems = []
      this.allSelected = false
      this.persistedFilters = {}
    },
    async checkProductsCount() {
      const authStore = useAuthStore()
      if (
        !isUnifiedCommerce() ||
        checkPermissions(
          { scopes: ['products:read'] },
          authStore.role,
          authStore.scopes
        )
      ) {
        try {
          const { data } = await th
            .products()
            .meta({ query: { deleted: false } })
          this.productsCount = data?.count || 0
        } catch (err) {
          this.$logException(err, { trackError: false })
          this.productsCount = 1
        }
      }
    }
  }
})
